import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../Common/Modal";
import FormInputField from "../../../FormInputField";
import CommonButton from "../../../Buttons/CommonButton";
import useForm from "../../../../hooks/useForm";
import HangTightLoading from "../../../Common/HangTightLoading";
import SuccessMessage from "../../../Common/SuccessMessage";
import {
  addBeneficiary,
  getBeneficiaryRequiredDetails,
} from "../../../../redux/actions/TRrequest/Beneficiary";
import ErrorMessage from "../../../Common/ErrorMessage";
import Label from "../../../Label";
import CountriesInput from "../../../Common/CountriesInput";
import useAllCountries from "../../../../hooks/useAllCountries";
import { useCurrencies } from "../../../../hooks";
import CurrenciesInput from "../../../Common/CurrenciesInput";
import { GetValidationErrors } from "../../../../helper";
import Dropdown from "../../../Dropdown";

const AddBeneficiaryModal = ({
  addBeneficiaryModalOpen,
  setaddBeneficiaryModalOpen,
  setRefreshBeneficiary,
  fromAccount = null,
  children,
}) => {
  const [isloading, setIsloading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [paymentTypeId, setPaymentTypeId] = useState(876);
  const client = useSelector((state) => state.clientProfiles.clientProfiles[0]);
  const [isSortCodeRequired, setIsSortCodeRequired] = useState(false);
  const [isSepaBeneficiary, setIsSepaBeneficiary] = useState(false);
  const [step, setStep] = useState(1);

  const account_number = useForm("");
  const iban = useForm("");
  const full_name = useForm("");
  const company_name = useForm("");
  const bank_name = useForm("");
  const swift_code = useForm("");
  const sort_code = useForm("");
  const bank_address = useForm("");
  const beneficiary_address = useForm("");
  const selectedBeneficiaryCountry = useForm("");
  const selectedBankBeneficiaryCountry = useForm("");
  const selectedCurrency = useForm("");
  const allCountries = useAllCountries();
  const currencies = useCurrencies("SEPA");
  const selectBeneficiaryType = useForm("");
  const bank_address_city = useForm("");
  const routing_number = useForm("");
  // const bank_address_postal_code = useForm("");
  const beneficiary_address_postal_code = useForm("");
  
  const beneficiary_state = useForm("");
  const beneficiary_city = useForm("");

  const allowPaymentTypes = [
    "SEPA",
    "SEPA_INSTANT",
    "TARGET2",
    "CHAPS",
    "FASTER_PAYMENTS",
  ];

  // Characters not allowed in the beneficiary address when currency is USD
  const USD_ADDRESS_FORBIDDEN_CHARS = /[\\|/(),.'`]/;
  const USD_ADDRESS_PATTERN = "^[^\\\\|/();,.'`]*$"; // HTML pattern equivalent

  // =======================
  // Beneficiary Details
  // =======================
  const beneficiaryDetails = [
    
    // selectedCurrency.value?.code !== "USD"
    //   ? {
    //       id: 2,
    //       name: "iban",
    //       label: "IBAN",
    //       required: false,
    //       type: "text",
    //       placeholder: "#### #### #### #### ##",
    //       value: iban.value,
    //       field: iban,
    //       onChange: iban.onChange,
    //       ...iban,
    //     }
    //   : null,

    selectBeneficiaryType.value === "company"
      ? {
          id: 3,
          name: "company_name",
          label: "Company Name",
          required: true,
          type: "text",
          placeholder: "Company name of the account holder",
          value: company_name.value,
          field: company_name,
          onChange: company_name.onChange,
        }
      : {
          id: 3,
          name: "full_name",
          label: "Full Name",
          required: true,
          type: "text",
          placeholder: "Full name of the account holder",
          value: full_name.value,
          field: full_name,
          onChange: full_name.onChange,
        },

    {
      id: 5,
      name: "beneficiary_address",
      label: "Beneficiary Address",
      required: true,
      type: "text",
      placeholder: "Address of the beneficiary",
      value: beneficiary_address.value,
      field: beneficiary_address,
      pattern:
        selectedCurrency.value?.code === "USD"
          ? USD_ADDRESS_PATTERN
          : "^[a-zA-Z0-9\\s,'-]*$",
      title:
        selectedCurrency.value?.code === "USD"
          ? "These characters are not allowed: \\ | / ( ) ; , . ' `"
          : undefined,
      onChange: (e) => {
        const val = e.target.value;
        // Block forbidden chars as the user types (USD only)
        if (
          selectedCurrency.value?.code === "USD" &&
          USD_ADDRESS_FORBIDDEN_CHARS.test(val)
        ) {
          beneficiary_address.setError(true);
          // console.log("Blocked char in beneficiary address: ", beneficiary_address.error);
          // return;
        }
        beneficiary_address.onChange(e);
      },
    },

    {
      id: 6,
      name: "beneficiary_state",
      label: "Beneficiary State/Region",
      required: true,
      type: "text",
      placeholder: "State/Region of the beneficiary",
      value: beneficiary_state.value,
      field: beneficiary_state,
      onChange: beneficiary_state.onChange,
    },
    {
      id: 7,
      name: "beneficiary_city",
      label: "Beneficiary City",
      required: true,
      type: "text",
      placeholder: "City of the beneficiary",
      value: beneficiary_city.value,
      field: beneficiary_city,
      onChange: beneficiary_city.onChange,
    },
    {
      id: 14,
      name: "beneficiary_address_postal_code",
      label: "Beneficiary Address Postal/Zip Code",
      required: true,
      type: "text",
      placeholder: "Postal/Zip code of the beneficiary (000000)",
      value: beneficiary_address_postal_code.value,
      field: beneficiary_address_postal_code,
      onChange: beneficiary_address_postal_code.onChange,
    },
  ].filter(Boolean);


  // =======================
  // Bank Beneficiary Details
  // =======================
  const bankBeneficiaryDetails = [
    {
      id: 1,
      name: "account_number",
      label: "Account Number",
      required: true,
      type: "number",
      placeholder: "########",
      value: account_number.value,
      field: account_number,
      onChange: account_number.onChange,
      ...account_number,
    },
    (selectedBankBeneficiaryCountry.value?.iso2 !== "us")
    ? {
        id: 2,
        name: "iban",
        label: "IBAN",
        required: false,
        type: "text",
        placeholder: "#### #### #### #### ##",
        value: iban.value,
        field: iban,
        onChange: iban.onChange,
        ...iban,
      }
    : null,
    {
      id: 8,
      name: "bank_name",
      label: "Bank Name",
      required: true,
      type: "text",
      placeholder: "Bank name of the beneficiary account",
      value: bank_name.value,
      onChange: bank_name.onChange,
    },
    {
      id: 9,
      name: "swift_code",
      label: "BIC/Swift Code",
      required: true,
      type: "text",
      placeholder: "Swift code of the beneficiary bank",
      value: swift_code.value,
      onChange: swift_code.onChange,
    },

    selectedCurrency.value?.code === "USD"
      ? {
          id: 10,
          name: "routing_number",
          label: selectedBankBeneficiaryCountry.value?.iso === "US" ? "Routing Number" : "Routing Number (Optional)",
          required: selectedBankBeneficiaryCountry.value?.iso === "US" ? true : false,
          type: "text",
          placeholder: "Routing number of the beneficiary bank",
          value: routing_number.value,
          onChange: routing_number.onChange,
        }
      : null,

    isSortCodeRequired
      ? {
          id: 11,
          name: "sort_code",
          label: selectedBankBeneficiaryCountry.value?.iso === "GB" ? "Sort Code" : "Sort Code (Optional)",
          required: selectedBankBeneficiaryCountry.value?.iso === "GB" ? true : false,
          type: "text",
          placeholder: "Sort code of the beneficiary bank account",
          value: sort_code.value,
          onChange: sort_code.onChange,
        }
      : null,

    {
      id: 12,
      name: "bank_address",
      label: "Beneficiary Bank Address",
      required: true,
      type: "text",
      placeholder: "Bank address of the beneficiary account",
      value: bank_address.value,
      // onChange: bank_address.onChange,

      pattern:
        selectedCurrency.value?.code === "USD"
          ? USD_ADDRESS_PATTERN
          : "^[a-zA-Z0-9\\s,'-]*$",
      title:
        selectedCurrency.value?.code === "USD"
          ? "These characters are not allowed: \\ | / ( ) ; , . ' `"
          : undefined,
      onChange: (e) => {
        const val = e.target.value;
        // Block forbidden chars as the user types (USD only)
        if (
          selectedCurrency.value?.code === "USD" &&
          USD_ADDRESS_FORBIDDEN_CHARS.test(val)
        ) {
          bank_address.setError(true);
          //console.log("Blocked char in beneficiary address: ", beneficiary_address.error);
          // return;
        }
        bank_address.onChange(e);
      },
    },
    {
      id: 13,
      name: "bank_address_city",
      label: "Bank Address City",
      required: true,
      type: "text",
      placeholder: "Bank address city of the beneficiary",
      value: bank_address_city.value,
      onChange: bank_address_city.onChange,
    },
  ].filter(Boolean);

  // const beneficiaryFields = [
  //   ...beneficiaryDetails,
  //   ...bankBeneficiaryDetails,
  // ];

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      selectedCurrency.value?.code === "USD" &&
      USD_ADDRESS_FORBIDDEN_CHARS.test(beneficiary_address.value)
    ) {
      beneficiary_address.setValue(
        beneficiary_address.value.replace(/[\\|/(),.'`]/g, "")
      );
    }
    // eslint-disable-next-line
  }, [selectedCurrency.value]);

  useEffect(() => {
    if (fromAccount && Array.isArray(currencies)) {
      let beneficiaryCurrency = currencies.find(
        (currency) => fromAccount.currency_code === currency.code
      );
      if (beneficiaryCurrency) {
        selectedCurrency.setValue(beneficiaryCurrency);
      }
    }
    // eslint-disable-next-line
  }, [fromAccount, currencies]);

  useEffect(() => {
    const fetchBeneficiaryDetails = async () => {
      if (
        addBeneficiaryModalOpen &&
        selectBeneficiaryType.value &&
        selectedBankBeneficiaryCountry.value?.iso2 &&
        selectedCurrency.value?.code
      ) {
        const beneficiary_type_map = {
          individual: "RETAIL",
          company: "CORPORATE",
        };

        const response = await dispatch(
          getBeneficiaryRequiredDetails(
            beneficiary_type_map[selectBeneficiaryType.value],
            selectedBankBeneficiaryCountry.value.iso2,
            selectedCurrency.value.code
          )
        ).catch((error) =>
          console.error("Error fetching beneficiary required details:", error)
        );

        const isSepaBeneficiary = response?.data?.some((item) => allowPaymentTypes.includes(item.paymentType));
        setIsSepaBeneficiary(isSepaBeneficiary);

        const isSortCodeRequired = response?.data?.some((item) =>
          item.requiredFieldsList?.some(
            (field) => field.fieldName === "sort_code" && field.required
          )
        );

        setIsSortCodeRequired(isSortCodeRequired);
        setPaymentTypeId(response.payment_type_id);
      }
    };
    fetchBeneficiaryDetails();
    // eslint-disable-next-line
  }, [
    addBeneficiaryModalOpen,
    selectBeneficiaryType.value,
    selectedBankBeneficiaryCountry.value,
    selectedCurrency.value,
  ]);

  const handleOnCloseModal = () => {
    setaddBeneficiaryModalOpen(false);
    setTimeout(() => {
      setSuccess(false);
      resetAllFields();
      setError(null);
      setStep(1);
    }, 500);
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);
    setError(null);

    let hasError = false;

    // Validate basic text fields
    const basicFields = [bank_name, bank_address, beneficiary_address];
    basicFields.forEach((field) => !field.validate() && (hasError = true));

    // Validate required dropdown fields
    const dropdownFields = [
      // selectedBeneficiaryCountry,
      selectedBankBeneficiaryCountry,
      // selectedCurrency,
    ];

    dropdownFields.forEach((field) => {
      if (!field.value.id) {
        field.setError(true);
        hasError = true;
        // setStep(1);
      }
    });

    if (hasError) {
      setError("Please select the required fields");
      return setIsloading(false);
    }

    const beneficiaryType = selectBeneficiaryType.value === "company";
    const fullName = full_name.value.trim();
    // const [firstName, ...rest] = fullName.split(" ");
    // const lastName = rest.join(" ");

    const uppercase = (value) => value?.toUpperCase?.() || ""; // helper

    // Build base data
    const data = {
      client_id: client.id,
      account_number: account_number.value,
      iban: iban.value,
      bank_name: bank_name.value,
      swift_code: swift_code.value,
      sort_code: sort_code.value,
      bank_address: bank_address.value,
      address: beneficiary_address.value,

      // Country & currency
      currency: uppercase(selectedCurrency.value.code),
      beneficiary_country: uppercase(selectedBeneficiaryCountry.value.iso2),
      bank_account_country: uppercase(selectedBankBeneficiaryCountry.value.iso2),

      beneficiary_type: beneficiaryType ? "CORPORATE" : "RETAIL",
      address_city: bank_address_city.value,
      address_postal_code: beneficiary_address_postal_code.value,
      payment_type_id: paymentTypeId,
      
      beneficiary_state: beneficiary_state.value,
      beneficiary_city: beneficiary_city.value,
    };

    // Add name fields based on beneficiary type
    if (beneficiaryType) {
      if (!company_name.validate()) {
        setIsloading(false);
        return;
      }
      data.name = company_name.value;
    } else {
      if (!full_name.validate()) {
        setIsloading(false);
        return;
      }
      data.name = fullName;
    }
    
    data.routing_number = routing_number.value;

    // API CALL
    try {
      const is_sepa_beneficiary = Boolean(paymentTypeId) && isSepaBeneficiary;

      const res = await dispatch(addBeneficiary(data, is_sepa_beneficiary));

      if (res.success) {
        setSuccess(true);
        resetAllFields();
        setRefreshBeneficiary(true);
      } else {
        if (res.errors) {
          setError(GetValidationErrors(res.errors));

          ["account_number", "iban"].forEach((field) => {
            if (res.errors[field]) {
              ({ account_number, iban })[field].setError(true);
            }
          });
        } else {
          setError(res.message ? res.message : res.error);
        }
      }
    } catch (error) {
      // console.log("Add beneficiary error: ", error);
      if (!success) setError(error.message);
    }

    setIsloading(false);
  };

  const resetAllFields = () => {
    account_number.reset();
    iban.reset();
    full_name.reset();
    bank_name.reset();
    swift_code.reset();
    sort_code.reset();
    bank_address.reset();
    beneficiary_address.reset();
    selectedBeneficiaryCountry.reset();
    selectedBankBeneficiaryCountry.reset();
    selectedCurrency.reset();
    selectBeneficiaryType.reset();
    company_name.reset();
  };

  const onSelectOption = (option, setOption) => {
    setOption.setValue(option);
    setOption.setError("");
  };

  // const isDisabled =
  //   selectBeneficiaryType.value &&
  //   selectedBeneficiaryCountry.value &&
  //   // selectedBankBeneficiaryCountry.value &&
  //   selectedCurrency.value;

  return (
    <>
      <div onClick={() => setaddBeneficiaryModalOpen(true)}>{children}</div>
      <Modal
        isOpen={addBeneficiaryModalOpen}
        handleOnCloseModal={handleOnCloseModal}
        header={isloading || success ? false : true}
        backButton={step > 1}
        backButtonAction={() => (step > 1 ? setStep(1) : null)}
        headerTitle={"Add new beneficiary"}
        className={`w-[432px] hide-scrollbar shadow-xl rounded-3xl overflow-scroll`}
      >
        {error && !isloading && (
          <div className="mx-6">
            <ErrorMessage message={error} onClose={() => setError(null)} />
          </div>
        )}
        {!isloading && !success && (
          <div className="px-6 pt-">
            <div className="modal-title">
              {step === 1 ? "Beneficiary details" : "Bank beneficiary details"}
            </div>

            {step === 1 && (
              <div className="my-2 space-y-2">
                {/* {isOpenPaydEnabled && ( */}
                <>
                  <Dropdown
                    id="select-beneficiary-dropdown"
                    name="select-beneficiary-dropdown"
                    placeholder="Select a beneficiary type"
                    label="Beneficiary type"
                    options={[
                      { label: "Company", value: "company" },
                      { label: "Individual", value: "individual" },
                    ]}
                    onChange={selectBeneficiaryType.onChange}
                    value={selectBeneficiaryType.value}
                    error={selectBeneficiaryType.error}
                  />
                  <CurrenciesInput
                    name="currency"
                    label="Currency"
                    placeholder="Choose your Currency"
                    currencies={currencies}
                    SelectedCurrency={selectedCurrency.value}
                    onChange={(option) =>
                      onSelectOption(option, selectedCurrency)
                    }
                    error={selectedCurrency.error}
                  >
                    <div>
                      <Label
                        htmlFor={"currency"}
                        className="block text-xs font-medium text-text-primary pb-1"
                        text="Currency"
                      />
                      <div className="flex items-center justify-betwee space-x-3">
                        <img
                          className="rounded-full w-8 h-8"
                          src={selectedCurrency.value.logo}
                          alt="flag"
                        />
                        <Label
                          htmlFor={"currency"}
                          className="text-sm font-medium text-text-primary"
                          text={`${selectedCurrency.value.name} (${selectedCurrency.value.code})`}
                        />
                      </div>
                    </div>
                  </CurrenciesInput>

                  <CountriesInput
                    name="beneficiary_country"
                    label="Beneficiary country"
                    placeholder="Choose your beneficiary country"
                    countries={allCountries}
                    SelectedCountry={selectedBeneficiaryCountry.value}
                    onChange={(option) =>
                      onSelectOption(option, selectedBeneficiaryCountry)
                    }
                    phonecode={false}
                    error={selectedBeneficiaryCountry.error}
                  >
                    <div>
                      <Label
                        htmlFor={"beneficiary_country"}
                        className="block text-xs font-medium text-text-primary pb-1"
                        text="Beneficiary country"
                      />
                      <div className="flex items-center justify-betwee space-x-3">
                        <img
                          className="rounded-full w-8 h-8"
                          src={selectedBeneficiaryCountry.value.flag}
                          alt="flag"
                        />
                        <Label
                          htmlFor={"beneficiary_country"}
                          className="text-sm font-medium text-text-primary"
                          text={`${selectedBeneficiaryCountry.value.name}`}
                        />
                      </div>
                    </div>
                  </CountriesInput>
                  
                  <form onSubmit={(e) => {
                      e.preventDefault();
                        // Validate required dropdown fields
                        const dropdownFields = [selectedBeneficiaryCountry, selectBeneficiaryType, selectedCurrency];
                        let hasError = false;
                        dropdownFields.forEach((field) => {
                          if (!field.value) {
                            field.setError(true);
                            hasError = true;
                          }
                        });

                        if (
                          selectedCurrency.value?.code === "USD" &&
                          USD_ADDRESS_FORBIDDEN_CHARS.test(beneficiary_address.value)
                        ) {
                          beneficiary_address.setError(true);
                          setError("Beneficiary address cannot contain \\ | / ( ) , . ' ` for USD");
                          hasError = true;
                        }

                        if (hasError === false) setStep(2);

                    }}>

                    <div className="my-2 space-y-2">
                      {beneficiaryDetails.map((field) => (
                        <FormInputField key={field.id} {...field} />
                      ))}
                    </div>
                    
                    <div className="flex justify-end pt-16 pb-3">
                      <CommonButton type="submit" >
                        Continue
                      </CommonButton>
                    </div>
                  </form>
                </>
                {/* )} */}
              </div>
            )}

            {step === 2 && (
              <div className="my-2 space-y-2">
                <CountriesInput
                  name="bank_account_country"
                  label="Beneficiary Bank account country"
                  placeholder="Choose your Bank account country"
                  countries={allCountries}
                  SelectedCountry={selectedBankBeneficiaryCountry.value}
                  onChange={(option) =>
                    onSelectOption(option, selectedBankBeneficiaryCountry)
                  }
                  phonecode={false}
                  error={selectedBankBeneficiaryCountry.error}
                >
                  <div>
                    <Label
                      htmlFor={"bank_account_country"}
                      className="block text-xs font-medium text-text-primary pb-1"
                      text="Bank account country"
                    />
                    <div className="flex items-center justify-betwee space-x-3">
                      <img
                        className="rounded-full w-8 h-8"
                        src={selectedBankBeneficiaryCountry.value.flag}
                        alt="flag"
                      />
                      <Label
                        htmlFor={"bank_account_country"}
                        className="text-sm font-medium text-text-primary"
                        text={`${selectedBankBeneficiaryCountry.value.name}`}
                      />
                    </div>
                  </div>
                </CountriesInput>
                <form onSubmit={handleOnSubmit}>
                  <div className="my-2 space-y-2">
                    {bankBeneficiaryDetails.map((field) => (
                      <FormInputField key={field.id} {...field} />
                    ))}
                  </div>
                  <div className="flex justify-end py-6">
                    <CommonButton type="submit">Create beneficiary</CommonButton>
                  </div>
                </form>
              </div>
            )}
          </div>
        )}

        {success && (
          <div className="p-6">
            <SuccessMessage
              title="Beneficiary added"
              description={`You've successfully added ${full_name.value} to your list of beneficiaries.`}
              handleCloseButton={handleOnCloseModal}
            />
          </div>
        )}

        {isloading && <HangTightLoading />}
      </Modal>
    </>
  );
};

export default AddBeneficiaryModal;
